import React from "react";
import Header from "../../../Components/share/header/Header";
import InteractiveBootCamp from "../../../Components/layouts/home/InterActiveBootCamp";
import Customers from "../../../Components/layouts/home/customers/Customers";
import PopularQuestions from "../../../Components/layouts/home/PopularQuestions/PopularQuestions";
import Distionction from "./Distionction";

function Home() {
    return (
        <div className="pt-12 overflow-hidden home">
            <Header />
            <Distionction />
            <InteractiveBootCamp />
            <Customers />
            <PopularQuestions />
        </div>
    );
}

export default Home;
